import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
// 3rd party
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import moment from 'moment';
// Models & Services
import { FormService } from '../../services/form.service';
import { BYTES_LONG, FormFieldOptions, MAX_FILE_SIZE_IMAGE, MAX_FILE_SIZE_VIDEO } from '../models/form-field';
// Other
import { environment } from '../../../../environments/environment';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';


@Component({
	selector: 'app-form-field',
	templateUrl: './form-field.component.html',
	styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent implements OnInit {
	@Input() type: string;
	@Input() options: FormFieldOptions;

	field: FormControl;
	isVideo: boolean;
	videoSrc;
	maxFileSize = MAX_FILE_SIZE_VIDEO;
	jsonEditor: string = '';
	isMulti = false;
	sizeLimitMessage: string = 'No exceder el limite de 100MB';

	get form(): RxFormGroup { return this.formService.form; }

	get isChecked(): boolean {
		const options = this.options.switchers;
		return this.field.value === (options.hasOwnProperty('trueValue') ? options.trueValue : true);
	}

	showPassword: boolean = false;

	togglePassword(): void {
	this.showPassword = !this.showPassword;
	}

	onFileSizeLimit(event: any) {
		this.sizeLimitMessage = `El archivo "${event.files[0].name}" excede el límite de 100 MB`;
		// Opcional: limpiar el archivo del componente
		event.files.forEach((file: any) => {
			const index = this.mediaResources.indexOf(file);
			if (index !== -1) {
				this.mediaResources.splice(index, 1);
			}
		});
	}

	datePicker = {
		isAnimated: true,
		adaptivePosition: true,
		dateInputFormat: 'YYYY-MM-DD',
		containerClass: 'theme-dark-blue'
	};
	mediaResources: any = [];

	private mediaResource: any;

	constructor(
		private formService: FormService,
		private sanitizer: DomSanitizer,
		private messageService: MessageService
	) { }

	ngOnInit(): void {
		this.field = this.form.get(this.options.path) as FormControl;
		this.isVideo = false;

		if (this.type === 'json_editor' && this.field.value !== '') {
			this.field.setValue(this.field.value);
		}

		if (this.type === 'select' &&
			(
				'multi' in this.options
				&& this.options?.multi
			)
		) {
			this.isMulti = true;
		}
	}


	bgImage(): String {
		return this.mediaResource
			|| (this.options.image && this.options.image.src)
			|| `${environment.apis.public}/assets/img/nofiles.png`;
	}

	bgStyle(): any {
		const imageString = JSON.stringify(this.bgImage()).replace(/\\n/g, '');
		const style = `url(${imageString})`;

		return this.sanitizer.bypassSecurityTrustStyle(style);
	}

	radioChange(event): void {
		this.field.markAsTouched();
		this.field.markAsDirty();
	}

	switched(event): void {
		const target = event.target;
		const options = this.options.switchers;
		this.field.setValue(target.checked ?
			(options.hasOwnProperty('trueValue') ? options.trueValue : true) :
			(options.hasOwnProperty('falseValue') ? options.falseValue : false));

		this.field.markAsTouched();
		this.field.markAsDirty();
	}

	onResourceMediaSelect(event: any, inputFile: FileUpload): void {
		this.isVideo = false;
		this.maxFileSize = MAX_FILE_SIZE_IMAGE;

		if (event.files && event.files[0]) {
			const file = (event.originalEvent.target as HTMLInputElement).files[0];

			if (file.type.includes('video/')) {
				this.maxFileSize = MAX_FILE_SIZE_VIDEO;
				const blobURL = URL.createObjectURL(file);
				this.videoSrc = this.transform(blobURL);
				this.isVideo = true;
			}

			if (file.size > this.maxFileSize) {
				inputFile.clear();
				if (inputFile.msgs.length <= 0) {
					inputFile.msgs.push({
						severity: 'error',
						summary: file.name,
						detail: `Tamaño de archivo invalido,
						maximo tamaño permitido es ${this.maxFileSize / BYTES_LONG} MB.`
					});
				}
				this.field.patchValue(null);
				return;
			}

			this.field.patchValue(file);
		}
	}

	removeFile(fileUploadComponent: FileUpload): void {
		this.field.patchValue(null);
		fileUploadComponent.clear();
	}

	public transform(url: string): SafeResourceUrl {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url);
	}

	onDateChange(event: any): void {
		if (event) {
			const format = moment(event).format(this.datePicker.dateInputFormat);
			this.field.patchValue(format);
		}
	}

	readFile(e): void {
		const input = e.target;
		if (input.files && input.files[0]) {
			const reader: FileReader = new FileReader();
			reader.readAsDataURL(input.files[0]);

			const t: Observable<any> = new Observable(observer => {
				reader.onloadend = (ev: any) => {
					observer.next(ev.target.result);
					observer.complete();
				};
			});

			t.subscribe(data => {
				this.mediaResource = data;
				this.field.setValue(data);
				// if (!avoidUpdateField) {
				//   this.field.setValue(data);
				// } else {
				//   const file = (input as HTMLInputElement).files[0];
				//   this.field.patchValue(file);
				// }

				this.field.markAsTouched();
				this.field.markAsDirty();
			});
		}
	}
}
